import React, { useState } from 'react'
import { submitDealerApplication } from '../lib/supabaseClient'

export default function DealerForm({ compact = false }) {
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [phone, setPhone] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const validate = () => {
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return 'Введите корректный email'
    }
    if (!fullName.trim() || fullName.trim().length < 3) {
      return 'Имя должно содержать минимум 3 символа'
    }
    return null
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    const validationError = validate()
    if (validationError) {
      setError(validationError)
      return
    }

    setSubmitting(true)
    try {
      const { error: apiError } = await submitDealerApplication({
        email: email.trim(),
        companyName: companyName.trim(),
        phone: phone.trim(),
        fullName: fullName.trim(),
      })
      if (apiError) {
        setError(apiError.message || 'Ошибка отправки. Попробуйте позже.')
        setSubmitting(false)
        return
      }
      setSubmitted(true)
      setFullName('')
      setEmail('')
      setCompanyName('')
      setPhone('')
    } catch (err) {
      setError('Ошибка отправки. Попробуйте позже.')
    } finally {
      setSubmitting(false)
    }
  }

  if (submitted) {
    return (
      <div className="rounded-xl bg-green-50 border border-green-100 p-6 text-center">
        <p className="text-green-800 font-medium">Заявка отправлена</p>
        <p className="text-green-600 text-sm mt-1">Мы свяжемся с вами в ближайшее время.</p>
      </div>
    )
  }

  if (compact) {
    return (
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Ваш email"
          className="flex-1 rounded-xl border border-ss-border bg-ss-gray px-4 py-2.5 text-sm text-ss-text outline-none transition-colors focus:border-ss-dark focus:bg-white"
        />
        <button
          type="submit"
          disabled={submitting}
          className={[
            'inline-flex justify-center items-center rounded-full px-6 py-2.5 text-sm font-medium text-white transition-all duration-300 active:scale-[0.98] shrink-0',
            submitting ? 'bg-ss-muted cursor-not-allowed' : 'bg-ss-dark hover:bg-[#333]',
          ].join(' ')}
        >
          {submitting ? (
            <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            'Стать дилером'
          )}
        </button>
        {error && (
          <p className="text-xs text-red-600 sm:sr-only">{error}</p>
        )}
      </form>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="df-name" className="block text-sm font-medium text-ss-text mb-1.5">
            ФИО <span className="text-red-500">*</span>
          </label>
          <input
            id="df-name"
            type="text"
            required
            minLength={3}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Иванов Иван"
            className="w-full rounded-xl border border-ss-border bg-ss-gray px-4 py-3 text-sm text-ss-text outline-none transition-colors focus:border-ss-dark focus:bg-white"
          />
        </div>
        <div>
          <label htmlFor="df-email" className="block text-sm font-medium text-ss-text mb-1.5">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            id="df-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.ru"
            className="w-full rounded-xl border border-ss-border bg-ss-gray px-4 py-3 text-sm text-ss-text outline-none transition-colors focus:border-ss-dark focus:bg-white"
          />
        </div>
        <div>
          <label htmlFor="df-company" className="block text-sm font-medium text-ss-text mb-1.5">
            Компания
          </label>
          <input
            id="df-company"
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="ООО «Аудио»"
            className="w-full rounded-xl border border-ss-border bg-ss-gray px-4 py-3 text-sm text-ss-text outline-none transition-colors focus:border-ss-dark focus:bg-white"
          />
        </div>
        <div>
          <label htmlFor="df-phone" className="block text-sm font-medium text-ss-text mb-1.5">
            Телефон
          </label>
          <input
            id="df-phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+7 (999) 000-00-00"
            className="w-full rounded-xl border border-ss-border bg-ss-gray px-4 py-3 text-sm text-ss-text outline-none transition-colors focus:border-ss-dark focus:bg-white"
          />
        </div>
      </div>

      {error && (
        <div className="rounded-xl bg-red-50 border border-red-100 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={submitting}
        className={[
          'inline-flex justify-center items-center rounded-full px-8 py-3.5 text-sm font-medium text-white transition-all duration-300 active:scale-[0.98]',
          submitting ? 'bg-ss-muted cursor-not-allowed' : 'bg-ss-dark hover:bg-[#333]',
        ].join(' ')}
      >
        {submitting ? (
          <span className="inline-flex items-center gap-2">
            <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            Отправка...
          </span>
        ) : (
          'Отправить заявку'
        )}
      </button>
    </form>
  )
}
